import './AboutUsStyles.css';
import React from 'react';


function AboutUs() {
    return(
        <div className="about-container">
            <h1>Our History</h1>
            <p>
The history of Morocco is rich and diverse,
 spanning thousands of years with influences from various civilizations and cultures.
  A website dedicated to trips in Morocco could include historical information to offer visitors 
  a deeper understanding of the country's past. 
Here an outline of historical aspects that could be featured:</p>
<h1>Our Mission</h1>
            <p>Morocco, as a nation,
                 might have several mission statements based on various aspects like tourism, development, 
                 culture, or diplomacy.
                  Crafting a mission statement for Morocco itself could encompass its aspirations,
                  values, and objectives as a country.
                 Here's a sample mission statement that aims to reflect Morocco's overarching goals:</p>
<h1>Our Vision</h1>
            <p>
The vision of Morocco typically encompasses the long-term 
aspirations and goals the nation aims to achieve.
 While specific visions can vary, 
here's a sample vision statement that encapsulates the overarching 
aspirations for the country:</p>
        </div>
    )
}

export default AboutUs;